export const styles = {
    link: {
        outline: 'none',
        color: '#000',
        textDecoration: 'none'
    },
    list: {
        width: 250,
        color: '#000',
        textDecoration: 'none'
    },
    fullList: {
        width: 'auto'
    },
    flex: {
      flexGrow: 1
    },
    logo: {
      color: '#fff',
      textDecoration: 'none'
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20
    },
    root: {
      flexGrow: 1
    },
    userButton: {
      color: '#fff'
    }
  };